import React from 'react'

const ButtonPrimaryForm = ({text, typeBtn, children}) => {
  return (
    <button
      className="bg-primary hover:bg-primary/90 border border-primary text-white px-3 py-1 rounded-sm flex items-center gap-2 font-light"
      type={`${typeBtn}`}
    >
      {children}
      {text}
    </button>
  )
}

export default ButtonPrimaryForm